import { render, staticRenderFns } from "./ChangeFile.vue?vue&type=template&id=58865574&scoped=true"
import script from "./ChangeFile.vue?vue&type=script&lang=js"
export * from "./ChangeFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58865574",
  null
  
)

export default component.exports